import {
  cardBase,
  homeColors,
  linkButtonReset,
  media,
  sectionLabel,
} from '../../tokens'

const styles = () => ({
  root: {
    ...cardBase,
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    padding: '22px 24px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  label: {
    ...sectionLabel,
    margin: 0,
  },
  toggle: {
    ...linkButtonReset,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '14px',
    color: homeColors.muted,
    '&:hover': {
      color: homeColors.navy,
    },
  },
  toggleIcon: {
    width: 12,
    height: 12,
    flex: 'none',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    columnGap: '32px',
    rowGap: '4px',
    [media.tablet]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    [media.phone]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
  item: {
    ...linkButtonReset,
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px',
    margin: '0 -8px',
    borderRadius: '10px',
    color: homeColors.ink,
    '&:hover': {
      background: homeColors.hover,
    },
  },
  itemIcon: {
    width: 32,
    height: 32,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    background: homeColors.iconSurface,
    color: homeColors.primary,
  },
  itemIconGlyph: {
    width: 18,
    height: 18,
  },
  itemTitle: {
    flex: 1,
    fontSize: '15px',
  },
  itemArrow: {
    width: 14,
    height: 14,
    flex: 'none',
    color: homeColors.subtle,
  },
})

export default styles
